export default "__VITE_ASSET__BhzajSwT__"